import React from 'react';
import LoadingScreen from '../LoadingScreen';
import Button from '../Button';
import { useAuthContext } from './AuthProvider';

const AuthGuard = ({ children }) => {
  const { handleLogin, initialized, user, isLoading } = useAuthContext();

  if (!initialized) {
    return <LoadingScreen />;
  }

  if (user && user.id) return children;

  return (
    <div className="flex flex-col gap-4 items-center justify-center h-screen">
      <h2 className="text-2xl font-bold">Login with Microsoft Account</h2>
      <Button disabled={isLoading} onClick={handleLogin}>
        {isLoading ? 'Loading...' : 'Login'}
      </Button>
    </div>
  );
};

export default AuthGuard;
